const HIDE_PRICE_FROM_BOM = 'HIDE_PRICE_FROM_BOM';
const INITIALIZE_PRICING = 'INITIALIZE_PRICING';

const state = {
  hideRetailPrice: false,
  hideDiscountPrice: false,
  hideWholeSalePrice: false
};

const actions = {
  toggleHidePriceFromBom({commit, state, rootState}, {property}) {
    const privs = rootState.user.accessPrivileges
    const canToggle = privs.includes('HIDE_PRICE_VALUES_ENABLED')
    const isDisabled = privs.includes('HIDE_PRICE_VALUES_DISABLED')
    const isHidden =
      (property.indexOf('retail') >= 0 && state.hideRetailPrice) ||
      (property.indexOf('wholesale') >= 0 && state.hideWholeSalePrice) ||
      (property.indexOf('discount') >= 0 && state.hideDiscountPrice)
    if (canToggle || (isHidden && !isDisabled)) {
      commit(HIDE_PRICE_FROM_BOM, {property})
    }
  },
  initializePricingVisibility({commit, rootState}) {
    commit(INITIALIZE_PRICING, rootState.user.accessPrivileges);
  }
};

const mutations = {
  [HIDE_PRICE_FROM_BOM](state, {property}) {
    if (property.indexOf('retail') >= 0) {
      state.hideRetailPrice = !state.hideRetailPrice;
    } else if (property.indexOf('wholesale') >= 0) {
      state.hideWholeSalePrice = !state.hideWholeSalePrice;
    } else if (property.indexOf('discount') >= 0) {
      state.hideDiscountPrice = !state.hideDiscountPrice;
    }
  },
  [INITIALIZE_PRICING](state, accessPrivileges) {
    state.hideRetailPrice = accessPrivileges.includes('HIDE_RETAIL_PRICE_INITIALLY');
    state.hideWholeSalePrice = accessPrivileges.includes('HIDE_WHOLESALE_PRICE_INITIALLY');
    state.hideDiscountPrice = accessPrivileges.includes('HIDE_DISCOUNTED_PRICE_INITIALLY');
  }
};

export default {
  state,
  actions,
  mutations
};
